import { render, staticRenderFns } from "./Page-GeneralSalesScreen.vue?vue&type=template&id=03a95aaf&"
import script from "./Page-GeneralSalesScreen.vue?vue&type=script&lang=js&"
export * from "./Page-GeneralSalesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports